<template>
  <div class="scroller w-auto stock-items-list">
    <Product :stock="item" @click="addToSale(item)"
             v-for="item in stockProducts" class="m-0"/>
  </div>
</template>

<script>
import Product from "@/components/point-of-sale/stock-search/Product";

export default {
  name: "StockItems",
  components: {Product},
  computed: {
    stockProducts() {
      return this.$store.getters.getStockProducts
          .filter((val, i) => i < 350)
          .filter(item => item.archived === false)
          .sort((a, b) => {
            if (a.Description < b.Description) return -1;
            if (a.Description > b.Description) return 1;
            // If Descriptions are the same, then sort by PLU
            if (a.PLU < b.PLU) return -1;
            if (a.PLU > b.PLU) return 1;
            return 0;
          });
    },
    customerDetails() {
      return this.$store.getters.getCustomer;
    },
    debtorCurrency() {
      return this.$store.getters.getDebtorCurrency;
    },
  },
  methods: {
    addToSale(item) {
      return this.$store.dispatch('getStockSetting', item.PLU)
          .then(async (set) => {
            if (!set) {
              set = { cookingLink: false, askForPrice: false, askForDescription: false, askForBoth: false };
            }
            // Preserve the server-supplied unit price precision (e.g.
            // 0.234). Truncating to 2 dp here was making the cart and
            // the invoice payload show 0.23 instead.
            let price = item.SellingIncl;
            let description = item.Description;

            if (set.askForDescription || set.askForBoth) {
              description = (await this.askForDescription(item));
            }

            if (set.askForPrice || set.askForBoth) {
              price = (await this.askForPrice(item));
              let rate = this.debtorCurrency;
              price *= rate.Rate;
            } else if (this.customerDetails) {
              price = this.$store.getters.getDebtorPrice({
                id : this.customerDetails,
                item : item
              });
            }

            if (set.cookingLink) {
              return this.$router.push({name: 'instruction', params: {plu: item.PLU}})
            }
            let obj = {
              Plu: item.PLU,
              Description: description,
              Qty: 1,
              Unit: price,
              // Line is a money total — keep at 2 dp.
              Line: Number((price * 1).toFixed(2)),
              Discount: 0,
              vat: 0,
              priceType : this.$store.getters.getCurrentDebtorPriceType.DiscountType,
              instructions: []
            }
            this.$store.commit('addToCurrentSaleLines', obj)
          })
    },
    askForPrice(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Selling Price`,
        html: `<h6 >Description : ${item.Description}</h6>
               <h6 >Current Price : ${item.SellingIncl}</h6>
               <input type="number" step="0.001" id="selling-prc" class="swal2-input" placeholder="Selling Price" style="max-width: 70%">`,
        confirmButtonText: 'Set Price',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#selling-prc').value;
          if (!value) {
            Swal.showValidationMessage(`Please enter a valid Selling Price`)
          }
          return parseFloat(value);
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        // Preserve the server-supplied price precision (e.g. 0.234)
        // instead of truncating to 2 dp.
        return item.SellingIncl;
      })
    },
    askForDescription(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Description`,
        html: `<h6 >Description : ${item.Description}</h6>
               <textarea id="desc-ask" class="swal2-input" placeholder="Description" style="max-width: 70%">`,
        confirmButtonText: 'Set Description',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#desc-ask').value
          if (!value || value.toString().trim() === "") {
            Swal.showValidationMessage(`Please enter a valid Description`)
          }
          return value;
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return item.Description
      })
    },

  }, watch: {}
}
</script>

<style lang="scss" scoped>
.stock-items-list {
  scroll-behavior: smooth;
  margin-bottom: 50px;
}

.grid-container {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: 32% 34% 32%;
  padding: 10px 10px 80px 10px;
  width: 100%;
  height: 100%;
}

@media screen and (min-width: 768px) and (max-width: 940px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 400px) {
  .grid-container {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}

@media (max-width: 650px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 650px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
